import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'fury-addcorporate',
  templateUrl: './addcorporate.component.html',
  styleUrls: ['./addcorporate.component.scss']
})
export class AddcorporateComponent implements OnInit {


  form: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    public dialogRef: MatDialogRef<AddcorporateComponent>,
    private fb: FormBuilder,
    private logger: NGXLogger) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      clienttypeadressepostale: ['', Validators.compose([Validators.required])],
      clienttypeemail: ['', Validators.compose([Validators.required, Validators.email])],
      clienttypelocalisation: ['', Validators.compose([Validators.required])],
      clienttyperaisonsocial: ['', Validators.compose([Validators.required])],
      clienttypestatutjuridique: ['', Validators.compose([Validators.required])],
      clienttypetelephone: ['', Validators.compose([Validators.required])]
    });
  }



  submit() {
    this.dialogRef.close(this.form.value);
  }

}
